export enum FindAllPaymentsSort {
  AMOUNT = 'amount',
  PAYMENT_TYPE = 'paymentType',
  CREATED_DATE = 'createdDate',
  UPDATED_DATE = 'updatedDate',
}
